import { logout } from './user.js';
import persistor from '../index';
import { REHYDRATE } from 'redux-persist/constants';
import { toggleNotification } from './notification';
import { API_ROOT } from '../components/constants/api';
import { isTokenValid } from '../utils/user';

export const ALL_APPS_DATA_RECIEVED = 'ALL_APPS_DATA_RECIEVED';
export const ALL_APPS_DATA_REQUESTED = 'ALL_APPS_DATA_REQUESTED';
export const SET_SELECTED_APP = 'SET_SELECTED_APP';

const initialState = {
  data: null,
  selectedApps: []
};

export default (state = initialState, action) => {
  switch (action.type) {
    case REHYDRATE:
      persistor.purge();
      return state;
    case ALL_APPS_DATA_RECIEVED:
      let appPayload = action.payload;
      return {
        ...state,
        data: appPayload.apps,
        status: ALL_APPS_DATA_RECIEVED
      };
    case ALL_APPS_DATA_REQUESTED:
      return {
        ...state,
        status: ALL_APPS_DATA_REQUESTED
      };
    case SET_SELECTED_APP:
      return {
        ...state,
        selectedApps: action.payload.tempApps
      };
    default:
      return state;
  }
};

export const getSelectedApps = tempApps => {
  return dispatch => {
    dispatch({
      type: SET_SELECTED_APP,
      payload: {
        tempApps: tempApps
      }
    });
  };
};
export const getAppsData = () => {
  return (dispatch, getState) => {
    dispatch({
      type: ALL_APPS_DATA_REQUESTED
    });
    const tokenExpiry = getState().user.expiresAt;
    if (!isTokenValid(tokenExpiry)) {
      dispatch(logout());
    }
    const appsUrl = API_ROOT + 'list?option=apps';
    const token = getState().user.token;
    const options = {
      method: 'GET',
      headers: {
        Xauthtoken: token,
        'Content-type': 'application/json'
      }
    };

    const message = 'We could not find application detail at this moment.';
    fetch(appsUrl, options)
      .then(response => {
        if (response.status >= 400) {
          if (response.status === 403) {
            dispatch(logout(false));
          }
          dispatch(toggleNotification(message));
          return null;
        }
        return response.json();
      })
      .then(json => {
        if (json !== null) {
          dispatch({
            type: ALL_APPS_DATA_RECIEVED,
            payload: {
              apps: json.apps
            }
          });
        }
      });
  };
};
